const sidMap = new Map();

export default sidMap;
